import { __RoomContext } from "../RoomProvider";
import { useContext } from "react";
export const NOT_INSIDE_ROOM_PROVIDER_ERROR = "No inside <RoomProvider />";
export const useCurrentRoom = () => {
    const context = useContext(__RoomContext);
    if (!context)
        throw Error(NOT_INSIDE_ROOM_PROVIDER_ERROR);
    return context;
};
